<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre" id="pgepubid00009">CONTENTS</h2>
<div class="center">
<table border="0" cellpadding="4" cellspacing="0" class="calibre13" summary="Contents">
<tbody class="calibre14"><tr class="calibre15"><td class="calibre18"><span class="smcap">chapter</span></td>
<td class="calibre16"> </td>
<td class="calibre18"><span class="smcap">page</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">I</td>
<td class="calibre16"><span class="smcap">To the Front</span></td>
<td class="calibre18"><a href="#/Text/Section0003">1</a></td>
</tr>
<tr class="calibre15"><td class="calibre18">II</td>
<td class="calibre16"><span class="smcap">Bad News</span></td>
<td class="calibre18"><a href="#/Text/Section0004">11</a></td>
</tr>
<tr class="calibre15"><td class="calibre18">III</td>
<td class="calibre16"><span class="smcap">Making Plans</span></td>
<td class="calibre18"><a href="#/Text/Section0005">17</a></td>
</tr>
<tr class="calibre15"><td class="calibre18">IV</td>
<td class="calibre16"><span class="smcap">Grace Surprises Her Chums</span></td>
<td class="calibre18"><a href="#/Text/Section0006">27</a></td>
</tr>
<tr class="calibre15"><td class="calibre18">V</td>
<td class="calibre16"><span class="smcap">A Problem Solved</span></td>
<td class="calibre18"><span href="#/Text/Section0007" title="Link target outside of Sample">37</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">VI</td>
<td class="calibre16"><span class="smcap">Life and Death</span></td>
<td class="calibre18"><span href="#/Text/Section0008" title="Link target outside of Sample">47</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">VII</td>
<td class="calibre16"><span class="smcap">The Race</span></td>
<td class="calibre18"><span href="#/Text/Section0009" title="Link target outside of Sample">56</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">VIII</td>
<td class="calibre16"><span class="smcap">Red Rags</span></td>
<td class="calibre18"><span href="#/Text/Section0010" title="Link target outside of Sample">65</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">IX</td>
<td class="calibre16"><span class="smcap">Thunder and Mud</span></td>
<td class="calibre18"><span href="#/Text/Section0011" title="Link target outside of Sample">75</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">X</td>
<td class="calibre16"><span class="smcap">The Knight of the Wayside</span></td>
<td class="calibre18"><span href="#/Text/Section0012" title="Link target outside of Sample">85</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XI</td>
<td class="calibre16"><span class="smcap">Mystery</span></td>
<td class="calibre18"><span href="#/Text/Section0013" title="Link target outside of Sample">95</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XII</td>
<td class="calibre16"><span class="smcap">Nearly an Accident</span></td>
<td class="calibre18"><span href="#/Text/Section0014" title="Link target outside of Sample">104</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XIII</td>
<td class="calibre16"><span class="smcap">Outwitting a Crank</span></td>
<td class="calibre18"><span href="#/Text/Section0015" title="Link target outside of Sample">114</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XIV</td>
<td class="calibre16"><span class="smcap">Bluff Point at Last</span></td>
<td class="calibre18"><span href="#/Text/Section0016" title="Link target outside of Sample">123</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XV</td>
<td class="calibre16"><span class="smcap">The Telegram</span></td>
<td class="calibre18"><span href="#/Text/Section0017" title="Link target outside of Sample">132</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XVI</td>
<td class="calibre16"><span class="smcap">The Shadow of Disaster</span></td>
<td class="calibre18"><span href="#/Text/Section0018" title="Link target outside of Sample">142</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XVII</td>
<td class="calibre16"><span class="smcap">Joe Barnes Again</span></td>
<td class="calibre18"><span href="#/Text/Section0019" title="Link target outside of Sample">152</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XVIII</td>
<td class="calibre16"><span class="smcap">Seriously Wounded</span></td>
<td class="calibre18"><span href="#/Text/Section0020" title="Link target outside of Sample">162</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XIX</td>
<td class="calibre16"><span class="smcap">Betty Confesses</span></td>
<td class="calibre18"><span href="#/Text/Section0021" title="Link target outside of Sample">170</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XX</td>
<td class="calibre16"><span class="smcap">Missing</span></td>
<td class="calibre18"><span href="#/Text/Section0022" title="Link target outside of Sample">180</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XXI</td>
<td class="calibre16"><span class="smcap">A Narrow Escape</span></td>
<td class="calibre18"><span href="#/Text/Section0023" title="Link target outside of Sample">187</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XXII</td>
<td class="calibre16"><span class="smcap">Darkness Before the Dawn</span></td>
<td class="calibre18"><span href="#/Text/Section0024" title="Link target outside of Sample">197</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XXIII</td>
<td class="calibre16"><span class="smcap">The Shadow Lifts</span></td>
<td class="calibre18"><span href="#/Text/Section0025" title="Link target outside of Sample">207</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XXIV</td>
<td class="calibre16"><span class="smcap">His Three Sweethearts</span></td>
<td class="calibre18"><span href="#/Text/Section0026" title="Link target outside of Sample">217</span></td>
</tr>
<tr class="calibre15"><td class="calibre18">XXV</td>
<td class="calibre16"><span class="smcap">Joy</span></td>
<td class="calibre18"><span href="#/Text/Section0027" title="Link target outside of Sample">227</span></td>
</tr>
</tbody>
</table>
</div>
<p class="calibre3"><span id="pgepubid00010" title="[1]"><a id="Page_1" title="[1]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?fe05f5c6